/**
 * GB API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { EgridMeta } from './egridMeta';
import { GbGeschaeftId } from './gbGeschaeftId';
import { HistInfoMeta } from './histInfoMeta';
import { GrundstueckId } from './grundstueckId';
import { CodeEntryMeta } from './codeEntryMeta';
import { GeometerGeschaeftIdMeta } from './geometerGeschaeftIdMeta';
import { GrundstueckListEntryMeta } from './grundstueckListEntryMeta';
import { GrundstueckNummerListEntry } from './grundstueckNummerListEntry';
import { GrundstueckPermissions } from './grundstueckPermissions';


export interface GrundstueckDetailEntryMeta { 
    permissions?: GrundstueckPermissions;
    mPermissions?: FieldMetaData;
    codeUnterart?: CodeEntryMeta;
    mCodeUnterart?: FieldMetaData;
    haengigeAvGeschaefteIds?: Array<GeometerGeschaeftIdMeta>;
    mHaengigeAvGeschaefteIds?: FieldMetaData;
    ligArt?: GrundstueckDetailEntryMeta.LigArtEnum;
    mLigArt?: FieldMetaData;
    modificationCounter?: number;
    mModificationCounter?: FieldMetaData;
    flaechenMaessigNichtAusgeschieden?: boolean;
    mFlaechenMaessigNichtAusgeschieden?: FieldMetaData;
    grundstueckArt?: GrundstueckDetailEntryMeta.GrundstueckArtEnum;
    mGrundstueckArt?: FieldMetaData;
    id: GrundstueckId;
    mId?: FieldMetaData;
    alpgrundstuecke?: Array<GrundstueckListEntryMeta>;
    mAlpgrundstuecke?: FieldMetaData;
    anzahlHaengigeAvGeschaefte?: number;
    mAnzahlHaengigeAvGeschaefte?: FieldMetaData;
    egrid?: EgridMeta;
    mEgrid?: FieldMetaData;
    sdrArt?: GrundstueckDetailEntryMeta.SdrArtEnum;
    mSdrArt?: FieldMetaData;
    grundstueckPDFpossible?: boolean;
    mGrundstueckPDFpossible?: FieldMetaData;
    grundstueckRTFpossible?: boolean;
    mGrundstueckRTFpossible?: FieldMetaData;
    dokulinkVerfuegbar?: GrundstueckDetailEntryMeta.DokulinkVerfuegbarEnum;
    mDokulinkVerfuegbar?: FieldMetaData;
    anzahlHaengigeAuftraege?: number;
    mAnzahlHaengigeAuftraege?: FieldMetaData;
    grundstueckNummern?: Array<GrundstueckNummerListEntry>;
    mGrundstueckNummern?: FieldMetaData;
    grundbuchFuehrung?: GrundstueckDetailEntryMeta.GrundbuchFuehrungEnum;
    mGrundbuchFuehrung?: FieldMetaData;
    haengigeGbGeschaefteIds?: Array<GbGeschaeftId>;
    mHaengigeGbGeschaefteIds?: FieldMetaData;
    isKopie?: boolean;
    mIsKopie?: FieldMetaData;
    eidgenoessischSeit?: string;
    mEidgenoessischSeit?: FieldMetaData;
    geloeschtDatum?: Date;
    mGeloeschtDatum?: FieldMetaData;
    anzahlHaengigeGbGeschaefte?: number;
    mAnzahlHaengigeGbGeschaefte?: FieldMetaData;
    histInfo?: HistInfoMeta;
    mHistInfo?: FieldMetaData;
}
export namespace GrundstueckDetailEntryMeta {
    export type LigArtEnum = 'STR' | 'CFA' | 'DPI' | 'VEC' | 'VIC' | 'ADG' | 'UEBRIGEART';
    export const LigArtEnum = {
        STR: 'STR' as LigArtEnum,
        CFA: 'CFA' as LigArtEnum,
        DPI: 'DPI' as LigArtEnum,
        VEC: 'VEC' as LigArtEnum,
        VIC: 'VIC' as LigArtEnum,
        ADG: 'ADG' as LigArtEnum,
        UEBRIGEART: 'UEBRIGEART' as LigArtEnum
    };
    export type GrundstueckArtEnum = 'STOCKWERK' | 'LIEGENSCHAFT' | 'MITEIGENTUM' | 'UNBEKANNT' | 'FOLIO' | 'BERGWERK' | 'SDR';
    export const GrundstueckArtEnum = {
        STOCKWERK: 'STOCKWERK' as GrundstueckArtEnum,
        LIEGENSCHAFT: 'LIEGENSCHAFT' as GrundstueckArtEnum,
        MITEIGENTUM: 'MITEIGENTUM' as GrundstueckArtEnum,
        UNBEKANNT: 'UNBEKANNT' as GrundstueckArtEnum,
        FOLIO: 'FOLIO' as GrundstueckArtEnum,
        BERGWERK: 'BERGWERK' as GrundstueckArtEnum,
        SDR: 'SDR' as GrundstueckArtEnum
    };
    export type SdrArtEnum = 'BAURECHT' | 'QUELLENRECHT' | 'KONZESSION' | 'UEBRIGES_RECHT';
    export const SdrArtEnum = {
        BAURECHT: 'BAURECHT' as SdrArtEnum,
        QUELLENRECHT: 'QUELLENRECHT' as SdrArtEnum,
        KONZESSION: 'KONZESSION' as SdrArtEnum,
        UEBRIGES_RECHT: 'UEBRIGES_RECHT' as SdrArtEnum
    };
    export type DokulinkVerfuegbarEnum = 'DOKULINK_VORHANDEN' | 'DOKULINK_NICHT_VORHANDEN';
    export const DokulinkVerfuegbarEnum = {
        DOKULINK_VORHANDEN: 'DOKULINK_VORHANDEN' as DokulinkVerfuegbarEnum,
        DOKULINK_NICHT_VORHANDEN: 'DOKULINK_NICHT_VORHANDEN' as DokulinkVerfuegbarEnum
    };
    export type GrundbuchFuehrungEnum = 'EIDGENOESSISCH' | 'KANTONAL' | 'BEREINIGUNG' | 'EINFUEHRUNG';
    export const GrundbuchFuehrungEnum = {
        EIDGENOESSISCH: 'EIDGENOESSISCH' as GrundbuchFuehrungEnum,
        KANTONAL: 'KANTONAL' as GrundbuchFuehrungEnum,
        BEREINIGUNG: 'BEREINIGUNG' as GrundbuchFuehrungEnum,
        EINFUEHRUNG: 'EINFUEHRUNG' as GrundbuchFuehrungEnum
    };
}


